import React from 'react';
import { getDeepValue } from '../../../../utils/index';
import CustomMenu from '../custom-menu/custom-menu';
import Image from '../../../../components/common/image/image';

import './roaming-menu.less';

export default class Menu extends React.Component<any, any> {
  static defaultProps: any = {
    moduleConfig: {},
    singleModule: false,
    currentPlotIndex: 0,
    currentHouseTypeIndex: 0,
    currentFloorIndex: 0,
    currentSceneIndex: 0,
    onClickPlot: null,
    onClickHouseType: null,
    onClickFloor: null,
    onClickScene: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      thumbActive: true,
    };
  }

  get allMenu() {
    const { moduleConfig, currentHouseTypeIndex, currentFloorIndex } = this.props;

    const result: any = {
      housesTypeMenuInfo: {},
      floorMenuInfo: {},
      scenesMenuInfo: {},
    };

    const groupsConfig = getDeepValue(moduleConfig, 'groups') || [];

    const housesTypeMenuInfo = {
      name: 'defaultPlot',
      type: 'title4',
      list: groupsConfig,
    };

    const scenesMenuInfo = getDeepValue(groupsConfig, `${currentHouseTypeIndex}.floors.${currentFloorIndex}`) || {};
    const scenes = getDeepValue(groupsConfig, `${currentHouseTypeIndex}.scenes`) || [];
    const scenesMap = getDeepValue(moduleConfig, 'scenes') || [];
    scenesMenuInfo.list = scenesMap.filter((item) => scenes.includes(item?.name));
    scenesMenuInfo.type = 'imgAndTit2';

    result.housesTypeMenuInfo = housesTypeMenuInfo;
    result.scenesMenuInfo = scenesMenuInfo;

    return result;
  }

  handleToggleThumbs = () => {
    this.setState({
      thumbActive: !this.state.thumbActive,
    });
  };

  // renderFloorMenu = info => {
  //   const { onClickFloor, currentFloorIndex } = this.props;
  //   const { list } = info;

  //   return list.floors.length > 1 ? (
  //     <div className={'menu-item'}>
  //       <div className="floor-wrapper">
  //         {list.floors.map((item, index) => (
  //           <div
  //             className={`floor-btn ${currentFloorIndex === index ? 'active' : ''}`}
  //             onClick={() => onClickFloor(index)}
  //             key={`floor${index}`}
  //           >
  //             {item.name}
  //           </div>
  //         ))}
  //       </div>
  //     </div>
  //   ) : null;
  // };
  renderThumbToggle = () => {
    const { singleModule } = this.props;
    const { thumbActive } = this.state;
    return (
      <div
        className={`thumb-toggle thumb-toggle-ui-v3 ${singleModule ? 'singleModule' : ''} ${
          thumbActive ? 'active' : ''
        }`}
        onClick={this.handleToggleThumbs}
      >
        <Image id='arrow' className='icon' />
      </div>
    );
  };

  render() {
    const { singleModule, currentHouseTypeIndex, currentSceneIndex, onClickHouseType, onClickScene } = this.props;
    const { thumbActive } = this.state;
    const renderThumbToggle = this.renderThumbToggle;

    const { housesTypeMenuInfo, scenesMenuInfo } = this.allMenu;
    const showHouseTypeList = housesTypeMenuInfo.list?.length > 1;
    const showSceneList = scenesMenuInfo.list?.length > 1 || showHouseTypeList;
    return (
      <>
        <div className={`thumbs ${singleModule ? 'singleModule' : ''}`}>
          {showHouseTypeList && (
            <CustomMenu
              levelInfo={housesTypeMenuInfo}
              activeIndex={currentHouseTypeIndex}
              onClickItem={(_, index) => {
                onClickHouseType(index);
              }}
              className={`house-type-list ${!thumbActive ? 'house-type-list-active' : ''}`}
            >
              {/* {this.renderFloorMenu(floorMenuInfo)} */}
            </CustomMenu>
          )}
          {showSceneList && (
            <CustomMenu
              className={`scene-list ${!thumbActive ? 'scene-list-active' : ''}`}
              levelInfo={scenesMenuInfo}
              activeIndex={currentSceneIndex}
              onClickItem={(_, index) => onClickScene(index)}
            />
          )}
          {showSceneList && renderThumbToggle()}
        </div>
      </>
    );
  }
}
